import { Controller } from "@hotwired/stimulus"

// Every referee action (score, cards, pause...) is a turbo_stream form that
// responds with `head :no_content` and shows nothing of its own on failure —
// over a flaky Ngrok/mobile connection, a failed tap looked identical to a
// successful one. This surfaces a toast whenever a submission fails, so
// silence stops meaning "it worked".
export default class extends Controller {
  static values = { message: String }

  connect() {
    this.onSubmitEnd = this.onSubmitEnd.bind(this)
    this.onFetchError = this.onFetchError.bind(this)
    document.addEventListener("turbo:submit-end", this.onSubmitEnd)
    document.addEventListener("turbo:fetch-request-error", this.onFetchError)
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.onSubmitEnd)
    document.removeEventListener("turbo:fetch-request-error", this.onFetchError)
  }

  onSubmitEnd(event) {
    if (!event.detail.success) this.showError()
  }

  onFetchError() {
    this.showError()
  }

  showError() {
    const toast = document.createElement("div")
    toast.setAttribute("role", "alert")
    toast.className = "fixed bottom-20 md:bottom-4 left-1/2 -translate-x-1/2 z-50 rounded-xl border border-red-300 bg-red-50 text-red-800 px-4 py-2.5 text-sm font-semibold shadow-lg max-w-[90vw] text-center"
    toast.textContent = this.messageValue
    document.body.appendChild(toast)

    setTimeout(() => {
      toast.classList.add("opacity-0", "transition-opacity", "duration-500")
      setTimeout(() => toast.remove(), 500)
    }, 4000)
  }
}
